export class TipoDestinatario {
    tipoDestinatarioId: number;
    nome: string;

    constructor(dtoTipoDestinatario: any) {
        this.tipoDestinatarioId = dtoTipoDestinatario.tipoDestinatarioID;
        this.nome = dtoTipoDestinatario.nome;
    }
}
